<div class="av-global-rail" aria-hidden="true">
  <av-rail [active]="wait.visible()" />
</div>
